import { Trash2 } from "lucide-react";
import { useListEditor, EditorShell } from "./EditorShell";

const Row = ({ value, i, ed, field, testId }) => (
  <tr data-testid={`${testId}-row-${i}`}>
    <td><input value={value} onChange={e => ed.update(i, { [field]: e.target.value })} maxLength={60} data-testid={`${testId}-name-${i}`} /></td>
    <td className="right"><button className="icon-only" onClick={() => ed.remove(i)} title="Sil" data-testid={`${testId}-delete-${i}`}><Trash2 size={14} /></button></td>
  </tr>
);

export default function SimpleListEditor({ title, sub, testId, initial, endpoint, field = "name", toPayload, newRow, column, addLabel, onSaved }) {
  const ed = useListEditor(initial, endpoint, toPayload || (rows => rows), onSaved);
  return <EditorShell title={title} sub={sub} testId={testId} ed={ed} addLabel={addLabel} onAdd={v => ed.add(newRow(v))}>
    <table className="settings-table"><thead><tr><th>{column}</th><th /></tr></thead>
      <tbody>{ed.rows.length ? ed.rows.map((r, i) => <Row key={i} value={r[field]} i={i} ed={ed} field={field} testId={testId} />) : <tr><td colSpan={2} className="empty-row">Liste boş.</td></tr>}</tbody></table>
  </EditorShell>;
}
